module.exports = __webpack_public_path__ + "static/media/interested_program_img.711cba4d.webp";